/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Folder_folderPortfolioItems = ReadonlyArray<{
    readonly __typename: "PortfolioItemV2";
    readonly " $refType": "Folder_folderPortfolioItems";
} | {
    /*This will never be '%other', but we need some
    value in case none of the concrete values match.*/
    readonly __typename: "%other";
    readonly " $refType": "Folder_folderPortfolioItems";
}>;
export type Folder_folderPortfolioItems$data = Folder_folderPortfolioItems;
export type Folder_folderPortfolioItems$key = ReadonlyArray<{
    readonly " $data"?: Folder_folderPortfolioItems$data;
    readonly " $fragmentRefs": FragmentRefs<"Folder_folderPortfolioItems">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Folder_folderPortfolioItems",
  "type": "PortfolioItemV2",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "__typename",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'da196c25d5f0eb1a44e37c24aca70d52';
export default node;
